export function reorderArray(arr, fromIdx, toIdx) {
  if (!Array.isArray(arr)) return [];
  if (
    fromIdx < 0 ||
    toIdx < 0 ||
    fromIdx >= arr.length ||
    toIdx >= arr.length ||
    fromIdx === toIdx
  ) {
    return arr.slice();
  }
  const next = arr.slice();
  const [moved] = next.splice(fromIdx, 1);
  next.splice(toIdx, 0, moved);
  return next;
}

export function applyColumnOrder(baseColumns, order) {
  if (!Array.isArray(baseColumns) || !baseColumns.length) return [];
  if (!Array.isArray(order) || !order.length) return baseColumns.slice();

  const byKey = new Map(baseColumns.map((column) => [column.key, column]));
  const seen = new Set();
  const ordered = [];

  for (const key of order) {
    const column = byKey.get(key);
    if (column && !seen.has(key)) {
      ordered.push(column);
      seen.add(key);
    }
  }

  for (const column of baseColumns) {
    if (!seen.has(column.key)) {
      ordered.push(column);
      seen.add(column.key);
    }
  }

  return ordered;
}

export function parseStoredColumnOrder(raw) {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed) && parsed.every((key) => typeof key === "string")) {
      return parsed;
    }
  } catch {
    // noop
  }
  return null;
}

export function buildOrderFromColumnItems(columns, order) {
  const visibleColumns = (columns || []).filter(
    (column) => column.visible !== false && column.key,
  );
  const visibleKeys = visibleColumns.map((column) => column.key);

  if (Array.isArray(order) && order.length) {
    const keySet = new Set(visibleKeys);
    const normalized = order.filter((key) => keySet.has(key));
    for (const key of visibleKeys) {
      if (!normalized.includes(key)) normalized.push(key);
    }
    return normalized;
  }

  return visibleKeys;
}

export function moveColumnInOrder(order, columnKey, direction) {
  const current = Array.isArray(order) ? order.slice() : [];
  const index = current.indexOf(columnKey);
  if (index === -1) return current;
  return reorderArray(current, index, index + direction);
}
